import { getWebinarsAction } from '../redux/Reducers/webinarsReducer';
import { BASE_URL } from './BASE_URL';

export const getWebinars = () => {
  return async (dispatch) => {
    const response = await fetch(BASE_URL + 'webinars/?limit=550');
    const data = await response.json();

    if (response.status === 200) {
      dispatch(getWebinarsAction(data));
    }
  };
};
